import { __assign } from 'tslib';
import * as React from 'react';
import 'classnames';
import '@invitae/nucleobase-analytics';
import '@invitae/nucleobase-engine-contentful';
import CompactHeader from '../../components/headers/CompactHeader/CompactHeader.esm.js';
import { GlobalNavigation } from '../../components/headers/GlobalNavigation/GlobalNavigation.esm.js';
import 'use-onclickoutside';
import '@invitae/iconograph-react';
import '@invitae/physician-cart';
import '@invitae/cms-blocks';
import 'lodash/omit';
import '../../context/NavigationCtaContext.esm.js';
import 'lodash/lowerCase';
import '@invitae/ids-react';
import '../../components/CountrySwitcher/CountrySwitcher.esm.js';
import 'lodash/toLower';
import '../../context/NavigationConfigContext.esm.js';
import 'lodash/debounce';
import '@invitae/react-hooks';
import { NucleobaseShellSignedInNavigation } from '../../components/headers/SignedInNavigation/NucleobaseShellSignedInNavigation.esm.js';
import '../../components/footers/HardcodedFooter/HardcodedFooter.esm.js';
import 'lodash';
import '@invitae/nucleobase-core';

var NavigationHeader = function (_a) {
    var BaseComponent = _a.BaseComponent, headerVariation = _a.headerVariation, navigationLayout = _a.navigationLayout, fields = _a.fields;
    var headerVariationTemp = headerVariation || navigationLayout;
    switch (headerVariationTemp) {
        case 'standard':
            return React.createElement(GlobalNavigation, __assign({ BaseComponent: BaseComponent }, fields));
        case 'compact':
            return React.createElement(CompactHeader, null);
        case 'signedIn':
            return React.createElement(NucleobaseShellSignedInNavigation, null);
        default:
            return React.createElement(GlobalNavigation, __assign({ BaseComponent: BaseComponent }, fields));
    }
};

export { NavigationHeader as default };
//# sourceMappingURL=NavigationHeader.esm.js.map
